import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ProgressCircleCheckedIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM10 14.17L16.59 7.58L18 9L10 17L6 13L7.41 11.59L10 14.17Z" />
    </SvgIcon>
);
export default ProgressCircleCheckedIcon;
